import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import jwtDecode from "jwt-decode";
import { withStyles } from "@material-ui/core/styles";
import {
  AppBar,
  Toolbar,
  Typography,
  Hidden,
  IconButton,
} from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import MenuIcon from "@material-ui/icons/Menu";
import { connect } from "react-redux";
import SnackBar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { Link as MuiLink } from "@material-ui/core";
import Axios from "axios";

import HomeIcon from "@material-ui/icons/Home";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import PublishIcon from "@material-ui/icons/Publish";

import ProfileMenu from "./ProfileMenu/ProfileMenu";
import { url } from "../../../../config/config";
import { logout } from "../../../../redux/action/action";
import ListNav from "./ListNav/ListNav";
import SearchBook from "./SearchBook/SearchBook";
import MobileDrawer from "./MobileDrawer/MobileDrawer";
import CartCount from "./Count/CartCount";
import MessageCount from "./Count/MessageCount";
import BookCount from "./Count/BookCount";
import SessionExpiredDialog from "../../../../Component/SessionExpiredDialog/SessionExpiredDialog";
import { useStyles } from "./Header.css";

const NavList = [
  {
    label: "Home",
    path: "/",
    icon: <HomeIcon />,
    type: "Public", //show when user is logged in or logged out
    accessToAuthor: true,
  },
  {
    label: "Books",
    path: "/books",
    icon: <MenuBookIcon />,
    type: "Public",
    accessToAuthor: false, //accessToAuthor false means author type cannot see this
  },
  {
    label: "Publish Book",
    path: "/book/publish/rules",
    icon: <PublishIcon />,
    type: "Author",
    accessToAuthor: true,
  },
];

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileOpen: false,
      ForLoggedOut: [],
      ToShowinNavbar: [],
      notificationOpen: true,
      loadingOpen: false,
      isVerified: false,
      toShow: "",
      searchResult: "",
      cartCount: 0,
      messageCount: 0,
      bookCount: 0,
      invoiceCount: 0,
      sessionExpired: false,
    };
  }

  componentDidMount() {
    this.showNav();
    if (this.props.isAuthor) {
      this.getData(this.props.authorToken);
      this.getMessageLength(this.props.authorToken);
      this.getBookLength(this.props.authorToken);
      this.getInvoiceLength(this.props.authorToken);
    } else if (this.props.isAuth) {
      this.getData(this.props.userToken);
      this.getCartLength();
    }
  }

  getData = (token) => {
    try {
      let data = jwtDecode(token);
      this.setState({
        toShow: data.firstName.charAt(0),
        isVerified: data.isVerified,
      });
    } catch (error) {}
  };

  getCartLength = async () => {
    try {
      const response = await Axios.get(`${url}/api/carts/cartDetails`, {
        headers: {
          "x-auth-token": this.props.userToken,
        },
      });
      this.setState({
        cartCount: response.data.cart.length,
      });
    } catch (error) {
      console.log("Finall");
      console.log("Header", error.response.data);
      if (error.response.data === "Invalid token.") {
        this.setState({
          sessionExpired: true,
        });
      }
    }
  };

  getMessageLength = async (token) => {
    try {
      let decodeData = jwtDecode(token);
      const response = await Axios.get(
        `${url}/api/messages/author/${decodeData._id}`,
        {
          headers: {
            "x-auth-token": token,
          },
        }
      );
      let newCount = response.data.messages.filter(
        (message) => message.seenByAuthor === false
      );
      this.setState({
        messageCount: newCount.length,
      });
    } catch (error) {
      if (error.response.data === "Invalid token.") {
        this.setState({
          sessionExpired: true,
        });
      }
    }
  };

  getBookLength = async (token) => {
    let decodeData = jwtDecode(token);
    const response = await Axios.get(`${url}/api/books/allBooks`, {
      params: {
        author: decodeData._id,
      },
      headers: {
        "x-auth-token": token,
      },
    });
    this.setState({
      bookCount: response.data.length,
    });
  };

  getInvoiceLength = async (authorToken) => {
    const response = await Axios.get(
      `${url}/api/authorInvoices/author/invoice`,
      {
        headers: {
          "x-auth-token": authorToken,
        },
      }
    );
    let newCount = response.data.filter((invoice) => invoice.paid === false);
    this.setState({
      invoiceCount: newCount.length,
    });
  };

  handleToggleDrawer = () => {
    this.setState({
      mobileOpen: !this.state.mobileOpen,
    });
  };

  showNav = () => {
    if (this.props.isAuth) {
      const filter = NavList.filter(
        (item) => item.type === "Public" || item.type === "Customer"
      );
      this.setState({
        ToShowinNavbar: filter,
      });
    } else if (this.props.isAuthor) {
      const filter = NavList.filter(
        (item) =>
          (item.type === "Public" || item.type === "Author") &&
          item.accessToAuthor === true
      );
      this.setState({
        ToShowinNavbar: filter,
      });
    } else {
      const filter = NavList.filter((item) => item.type === "Public");
      this.setState({
        ForLoggedOut: filter,
      });
    }
  };

  handleNotificationClose = () => {
    this.setState({
      notificationOpen: false,
    });
  };

  handleLoadingOpen = () => {
    this.setState({
      loadingOpen: true,
    });
  };

  handleLoadingClose = () => {
    this.setState({
      loadingOpen: false,
    });
  };

  showLoadingNotification = () => {
    return (
      <SnackBar
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        open={this.state.notificationOpen}
        onClose={this.handleLoadingClose}
        style={{ top: 80, left: 10 }}
      >
        <MuiAlert
          onClose={this.handleLoadingClose}
          severity="info"
          elevation={6}
          variant="filled"
        >
          Please Wait...
        </MuiAlert>
      </SnackBar>
    );
  };

  handleConfirmMail = async (e) => {
    e.preventDefault();
    this.handleLoadingOpen();
    if (this.props.isAuth) {
      const response = await Axios.post(
        `${url}/api/email/verificationEmail`,
        null,
        {
          headers: { "x-auth-token": this.props.userToken },
        }
      );
      if (response.data.success) {
        this.props.history.push("/confirmationPage");
      }
    }
    if (this.props.isAuthor) {
      const response2 = await Axios.post(
        `${url}/api/email/author/verificationEmail`,
        null,
        {
          headers: { "x-auth-token": this.props.authorToken },
        }
      );
      if (response2.data.success) {
        this.props.history.push("/confirmationPage");
      }
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        {this.state.sessionExpired === true && (
          <SessionExpiredDialog logout={() => this.props.logout()} />
        )}
        <Hidden smUp implementation="css">
          <MobileDrawer
            mobileOpen={this.state.mobileOpen}
            handleToggleDrawer={this.handleToggleDrawer}
            list={
              this.props.isAuth || this.props.isAuthor
                ? this.state.ToShowinNavbar
                : this.state.ForLoggedOut
            }
          />
        </Hidden>

        <AppBar
          position={this.props.position ? this.props.position : "fixed"}
          className={classes.appbarStyle}
        >
          <div className={classes.sectionDesktop}>
            <Toolbar className={classes.desktopToolbar} style={{ height: 80 }}>
              <MuiLink href="/" className={classes.title}>
                Digi-Book
              </MuiLink>

              <div className={classes.headerPart} style={{ flexGrow: 1 }}>
                <ListNav
                  list={
                    this.props.isAuth || this.props.isAuthor
                      ? this.state.ToShowinNavbar
                      : this.state.ForLoggedOut
                  }
                />
                {this.props.isAuthor === true ? null : <SearchBook />}
              </div>

              {this.props.isAuth || this.props.isAuthor ? (
                this.props.isAuth ? (
                  <CartCount
                    badgeContent={
                      this.props.cartCount >= 0
                        ? this.props.cartCount
                        : this.state.cartCount
                    }
                  />
                ) : (
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <MessageCount
                      badgeContent={
                        this.props.messageCount >= 0
                          ? this.props.messageCount
                          : this.state.messageCount
                      }
                      label="Messages"
                    />
                    <BookCount
                      badgeContent={
                        this.props.bookCount >= 0
                          ? this.props.bookCount
                          : this.state.bookCount
                      }
                      label="My Books"
                    />
                  </div>
                )
              ) : null}

              <div className={classes.buttonStyle}>
                {this.props.isAuth || this.props.isAuthor ? (
                  <ProfileMenu toShow={this.state.toShow} />
                ) : (
                  <div style={{ color: "#fff" }}>
                    <div style={{ marginBottom: 5 }}>Login As</div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Link
                        to="/login/Customer"
                        className={classes.linkStyle}
                        style={{ marginRight: 10 }}
                      >
                        User
                      </Link>
                      <Divider
                        flexItem
                        orientation="vertical"
                        style={{ backgroundColor: "#fff" }}
                      />
                      <Link
                        to="/login/Author"
                        className={classes.linkStyle}
                        style={{ marginLeft: 10 }}
                      >
                        Author
                      </Link>
                    </div>
                  </div>
                )}
              </div>
            </Toolbar>
          </div>

          <div className={classes.sectionMobile}>
            <Toolbar style={{ width: "100%", height: 70 }}>
              <IconButton
                onClick={this.handleToggleDrawer}
                className={classes.menuButton}
              >
                <MenuIcon style={{ color: "#fff", width: 25, height: 25 }} />
              </IconButton>
              <div>
                <Typography
                  variant="h5"
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <MuiLink href="/" className={classes.title}>
                    Digi-Book
                  </MuiLink>
                </Typography>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  flexGrow: 1,
                }}
              >
                {this.props.isAuth || this.props.isAuthor ? (
                  this.props.isAuth ? (
                    <CartCount
                      badgeContent={
                        this.props.cartCount >= 0
                          ? this.props.cartCount
                          : this.state.cartCount
                      }
                    />
                  ) : (
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <MessageCount
                        badgeContent={
                          this.props.messageCount >= 0
                            ? this.props.messageCount
                            : this.state.messageCount
                        }
                      />
                      <BookCount
                        badgeContent={
                          this.props.bookCount >= 0
                            ? this.props.bookCount
                            : this.state.bookCount
                        }
                      />
                    </div>
                  )
                ) : null}
              </div>

              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                {(this.props.isAuth || this.props.isAuthor) && (
                  <ProfileMenu toShow={this.state.toShow} />
                )}
              </div>
            </Toolbar>
          </div>
        </AppBar>
        {this.state.loadingOpen && this.showLoadingNotification()}

        {(this.props.isAuth || this.props.isAuthor) &&
          this.state.isVerified === false && (
            <SnackBar
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              open={this.state.notificationOpen}
              onClose={this.handleNotificationClose}
              className={classes.notificationStyle}
            >
              <MuiAlert
                onClose={this.handleNotificationClose}
                className={classes.notificationAlert}
                severity="warning"
                elevation={6}
                variant="filled"
              >
                Your email address is not verified.
                <label
                  style={{
                    color: "black",
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                  onClick={this.handleConfirmMail}
                >
                  Verify Email
                </label>
              </MuiAlert>
            </SnackBar>
          )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuth: state.UserReducer.isAuth,
    userToken: state.UserReducer.token,
    isAuthor: state.AuthorReducer.isAuthor,
    authorToken: state.AuthorReducer.authorToken,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => {
      dispatch(logout());
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(Header)));
